import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import pl from './locales/pl.json'

const resources = {
  en,
  pl
}

i18n.use(initReactI18next).init({
  resources,
  debug: true,
  lng: 'pl',
  fallbackLng: 'pl',
  supportedLngs: ['pl', 'en'],
  nonExplicitSupportedLngs: true,
  load: 'languageOnly',
  interpolation: {
    escapeValue: false
  }
})

export default i18n
